import { useMutation } from "@tanstack/react-query";
import { toastErrorApi, toastExito } from "@/lib/toast";
import { contabilizacionApi } from "../services/contabilizacion.api";

/**
 * Descarga el TXT de una póliza individual. No tiene toast de éxito ·
 * el archivo aparece en la barra del browser, eso es feedback suficiente.
 */
export function useDescargarPolizaTxt(solicitudId: string) {
  return useMutation({
    mutationFn: ({ polizaId, nombre }: { polizaId: string; nombre: string }) =>
      contabilizacionApi.descargarPolizaTxt(solicitudId, polizaId, nombre),
    onError: toastErrorApi,
  });
}

/**
 * Descarga TODAS las pólizas depositadas como un ZIP. Acá sí toast,
 * porque el archivo es uno solo con un nombre derivado que el usuario
 * podría no esperar.
 */
export function useDescargarPolizasZip(solicitudId: string) {
  return useMutation({
    mutationFn: () => contabilizacionApi.descargarPolizasZip(solicitudId),
    onSuccess: () => toastExito({ title: "ZIP descargado", message: "Pólizas descargadas correctamente." }),
    onError: toastErrorApi,
  });
}
